import useApi from "@/hooks/useApi";
import { useEffect, useEffectEvent, useRef, useState } from "react";
import { IoMdMenu } from "react-icons/io";
import { useSidebarStore } from "../Layout/Store";
import Avatar from "../Avatar";
import BoxProfile from "./Components/BoxProfile";
import Notification from "./Components/Notification";
import GlobalSearch from "./Components/GlobalSearch";
import { showErrorAlert, resolveAvatarUrl } from "@/Utils";
import { useLoggedUserStore } from "@/Store";

import S from "./styles.module.scss";

import { ISidebar } from "../../types/ISidebar";
import { useLocation } from "react-router-dom";

const Header = ({ sidebarData }: ISidebar) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const { getRequest } = useApi();
  const location = useLocation();
  const loggedUser = useLoggedUserStore((state) => state.loggedUser);
  const isAdmin = ["superadmin", "owner", "admin"].includes(
    loggedUser?.type ?? ""
  );

  const {
    handleOpenSidebar,
    boxProfileOpen,
    toggleBoxProfile,
    closeBoxProfile,
  } = useSidebarStore();
  const boxRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const headerTitle = sidebarData
    .flatMap((item) => {
      if (item.submenu) {
        return item.submenu
          .filter((subitem) => location.pathname === subitem.path)
          .map((subitem) => `${item.label} > ${subitem.label}`);
      }

      return location.pathname === item.path ? [item.label] : [];
    })
    .join("");

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Node)) return;

      if (
        boxRef.current &&
        !boxRef.current.contains(target) &&
        buttonRef.current &&
        !buttonRef.current.contains(target)
      ) {
        closeBoxProfile();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeBoxProfile]);

  const fetchUser = useEffectEvent(async () => {
    try {
      const response = await getRequest("/api/user");
      const data = await response.json();

      setName(data.name);
      setEmail(data.email);
    } catch (error) {
      showErrorAlert(error);
    }
  });

  useEffect(() => {
    void fetchUser();
  }, []);

  return (
    <header className={S["header-container"]}>
      <div className={S["menu-icon"]}>
        <IoMdMenu className={S.icon} size={24} onClick={handleOpenSidebar} />
      </div>
      <h2>{headerTitle}</h2>
      <div className={S["menu-right"]}>
        {isAdmin && <GlobalSearch />}
        <Notification />
        <button ref={buttonRef} onClick={toggleBoxProfile}>
          <Avatar size={32} src={resolveAvatarUrl(loggedUser?.image)} />
        </button>
      </div>
      {boxProfileOpen && (
        <BoxProfile
          ref={boxRef}
          name={name}
          email={email}
          image={loggedUser?.image}
        />
      )}
    </header>
  );
};

export default Header;

